import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Box from '@material-ui/core/Box';

import { makeStyles } from '@material-ui/core/styles';

import {
  specificRiskRiskyDna,
  specificRiskNotRisky,
  specificRiskModerate,
} from 'on_web/assets/imageList';

import { useTranslation } from 'react-i18next';

import TraitRisk from 'on_web/components/shared/TraitRisk/TraitRisk';
import TraitDescription from 'on_web/components/shared/TraitDescription/TraitDescription';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontFamily: 'Museo',
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.1,
    letterSpacing: 'normal',
    textAlign: 'left',
  },
  text: {
    fontSize: '20px',
    fontFamily: 'Museo',
    fontWeight: 'bold',
  },
  text2: {
    fontSize: '16px',
    fontFamily: 'Museo',
  },
}));

export default function TraitAccordion(props) {
  const classes = useStyles();

  const { t } = useTranslation();
  return (
    <Accordion className={classes.root} defaultExpanded={props.defaultExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box display="flex" alignItems="center">
          <Box marginRight={3}>
            <img
              alt="risk"
              src={
                props.trait.assessment_level === 2
                  ? specificRiskRiskyDna
                  : props.trait.assessment_level === 1
                  ? specificRiskModerate
                  : specificRiskNotRisky
              }
            />
          </Box>

          <Typography className={classes.heading}>
            {props.trait.trait.name}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box px={'20px'} py={'12px'}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >
            <Grid item>
              <Box px={'20px'}>
                <TraitRisk
                  riskLevel={props.trait.assessment_level}
                  riskLabel={props.trait.assessment_label}
                />
              </Box>
            </Grid>
            <Grid item xs>
              <TraitDescription
                description={props.trait.trait.description}
                name={props.trait.trait.name}
                explanation={props.trait.explanation}
              />
            </Grid>
          </Grid>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
